import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ICampaignScreen } from '../../../models';

@Component({
  selector: 'app-screen-quick-view',
  imports: [MatDialogModule, CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './screen-quick-view.component.html',
  styleUrl: './screen-quick-view.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class ScreenQuickViewComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; screens: ICampaignScreen[] },
    private dialogRef: MatDialogRef<ScreenQuickViewComponent>
  ) { }

  close(): void {
    this.dialogRef.close();
  }
}
